export default "__VITE_ASSET__G9z3gNAW__"